import AddressTypes from 'common/Forms/AddressTypes';
import { GetCommonCombinedFormWellFormedAddress, GetCommonCombinedFormFieldPathValueMap } from 'common/Addresses/AddressFormatters/Shared/AddressFormatHelper';

export function GetFieldPathValueMap(addressProps, wellFormedAddress) {
  switch (addressProps?.addressType) {
    case AddressTypes.Permanent:
      return GetCommonCombinedFormFieldPathValueMap('part1.permanentAddress', wellFormedAddress);
    case AddressTypes.Mailing:
      return GetCommonCombinedFormFieldPathValueMap('part1.mailingAddress', wellFormedAddress);
    default:
      break;
  }
}

export function GetWellFormedAddress(addressProps, addressValues) {
  switch (addressProps?.addressType) {
    case AddressTypes.Permanent:
      return GetCommonCombinedFormWellFormedAddress(addressValues?.part1?.permanentAddress);
    case AddressTypes.Mailing:
      return GetCommonCombinedFormWellFormedAddress(addressValues?.part1?.mailingAddress);
    default:
      break;
  }
}
